<template>
  <div id="administracao-chamada-publica" class="container">
    <div class="row">
      <div class="col text-right">
        <a
          class="btn btn-info"
          style="height: unset; align-items: center"
          data-toggle="modal"
          data-target="#modal_cadastro_chamada_publica"
          >Cadastrar</a
        >
      </div>
    </div>
    <br />
    <table class="table table-striped table-hover table-sm" style="width: 100%">
      <thead>
        <tr>
          <th>Município</th>
          <th>Início</th>
          <th>Término</th>
          <th>Link</th>
          <th></th>
        </tr>
      </thead>
      <tbody v-if="chamadasPublicas.length > 0">
        <tr v-for="payload in chamadasPublicas" :key="payload.chamadaPublicaId">
          <th>{{ payload.municipio.nome }}</th>
          <th>{{ payload.inicioString }}</th>
          <th>{{ payload.terminoString }}</th>
          <th>{{ payload.link }}</th>
          <th>
            <a
              data-toggle="modal"
              data-target="#modal_editar_chamada_publica"
              @click="mudarChamadaPublicaSelecionada(payload)"
              >Editar</a
            >
            /
            <a @click="excluirChamadaPublica(payload)">Excluir</a>
          </th>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <th colspan="4">Não há chamadas públicas cadastradas</th>
        </tr>
      </tbody>
    </table>

    <modal-cadastro-chamadas-publicas
      @atualizar-listagem="listarChamadasPublicas()"
    ></modal-cadastro-chamadas-publicas>
    <modal-editar-chamadas-publicas
      :payload="chamadaPublicaSelecionada"
      @atualizar-listagem="listarChamadasPublicas()"
    ></modal-editar-chamadas-publicas>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { chamadaPublicaAPI } from "@/modules/home";
import ModalCadastroChamadasPublicas from "./ModalCadastroChamadasPublicas.vue";
import ModalEditarChamadasPublicas from "./ModalEditarChamadasPublicas.vue";

export default {
  data() {
    return {
      chamadasPublicas: [],
      chamadaPublicaSelecionada: {},
    };
  },
  components: {
    ModalCadastroChamadasPublicas,
    ModalEditarChamadasPublicas,
  },
  methods: {
    ...mapActions(["setLoading"]),
    listarChamadasPublicas() {
      this.setLoading(true);
      chamadaPublicaAPI
        .list()
        .then((resp) => {
          this.chamadasPublicas = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$toast.error("Erro ao listar chamadas públicas");
        });
    },
    excluirChamadaPublica(payload) {
      chamadaPublicaAPI
        .delete(payload.chamadaPublicaId)
        .then((resp) => {
          this.chamadasPublicas = resp.data;
          this.setLoading(false);
          this.listarChamadasPublicas();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$toast.error("Erro ao excluir chamada pública");
        });
    },
    mudarChamadaPublicaSelecionada(chamadaPublica) {
      this.chamadaPublicaSelecionada = chamadaPublica;
    },
  },
  mounted() {
    this.listarChamadasPublicas();
  },
};
</script>
